import { createSelector } from '@reduxjs/toolkit';
import { employeesNotDeleted } from './employees-not-deleted';
import type { EmployeeViewModel } from '@trinnvis/dabih-api-client';
import type { NameEntry } from 'src/store/selectors';

export const employeesShortNames = createSelector(employeesNotDeleted, function (employees: EmployeeViewModel[]): {
  uuid: string;
  status: string;
  name: string;
}[] {
  const result: NameEntry[] = [];
  employees.forEach(function (e) {
    let status = '';
    if (e.status) {
      status = e.status;
    }
    let firstName = e.firstName ?? '';
    const firstNames = firstName.split(' ');
    if (firstNames.length > 1) {
      firstName = firstNames[0];
      for (let i = 0; i < firstNames.length; i++) {
        if (i !== 0 && firstNames[i]) {
          firstName += ' ' + firstNames[i].substring(0, 1) + '.';
        }
      }
    }
    let shortName = firstName;
    const othersWithSameFirstName = employees.filter(function (employee) {
      return firstName === employee.firstName && e.uuid !== employee.uuid;
    });
    if (othersWithSameFirstName.length) {
      shortName = firstName + ' ' + e.lastName.substring(0, 1) + '.';
      const othersWithSameFirstNameAndLastInitial = othersWithSameFirstName.filter(function (employee) {
        return e.lastName.startsWith(employee.lastName.substring(0, 1));
      });
      if (othersWithSameFirstNameAndLastInitial.length) {
        shortName = firstName + ' ' + e.lastName;
      }
    }
    result.push({ uuid: e.uuid, status: status, name: shortName, phone: e.phone, email: e.email });
  });
  return result;
});
